import { render, staticRenderFns } from "./brand-dialog.vue?vue&type=template&id=80048d22&"
import script from "./brand-dialog.vue?vue&type=script&lang=js&"
export * from "./brand-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports